import apiBase from 'src/api/api-base';
import Client from 'src/models/client';

// Anagrafica clienti (rotte /clients del backend, non le clients environment-scoped del template).
const CLIENTS = '/clients';
const clientUrl = (id: number | string) => `/clients/${id}`;

const buildFormData = (client: any, method?: 'PUT'): FormData => {
  const formData = new FormData();
  if (method) {
    formData.append('_method', method);
  }
  Object.keys(client).forEach((key) => {
    const value = client[key];
    if (key === 'logo') {
      if (value instanceof File) {
        formData.append('logo', value);
      }
      return; // logo esistente (URL) non si re-invia
    }
    if (value !== undefined && value !== null) {
      formData.append(key, value.toString());
    }
  });
  return formData;
};

export const getAllClients = async (): Promise<Client[]> =>
  new Promise((resolve, reject) => {
    apiBase
      .get(CLIENTS)
      .then((response) => resolve(response.data as Client[]))
      .catch(reject);
  });

export const createClient = async (client: any): Promise<Client> =>
  new Promise((resolve, reject) => {
    const payload = client.logo instanceof File ? buildFormData(client) : client;
    apiBase
      .post(CLIENTS, payload)
      .then((response) => resolve(response.data as Client))
      .catch(reject);
  });

export const updateClient = async (client: any): Promise<Client> =>
  new Promise((resolve, reject) => {
    if (client.logo instanceof File) {
      apiBase
        .post(clientUrl(client.id), buildFormData(client, 'PUT'))
        .then((response) => resolve(response.data as Client))
        .catch(reject);
      return;
    }
    apiBase
      .put(clientUrl(client.id), client)
      .then((response) => resolve(response.data as Client))
      .catch(reject);
  });

export const deleteClient = async (id: number | string): Promise<Client> =>
  new Promise((resolve, reject) => {
    apiBase
      .delete(clientUrl(id))
      .then((response) => resolve(response.data as Client))
      .catch(reject);
  });
